import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { TRANSLATION_CONFIG } from '../providers/translation-tokens';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private config = inject(TRANSLATION_CONFIG);

  getTranslation(language: string) {
    // return this.http.get<Translation>(`/i18n/${language}/${this.config?.scope || 'common' }`);
    return this.http.get<Translation>(`/i18n/${language}/?scopes=common,${this.config.scope}`);
  }
}